import { html, render } from 'lit-html';

export class GroceryView {
  constructor() {
    this.app = document.getElementById('groceryList');
    this.itemInput = document.getElementById('addItem');
    this.quantityInput = document.getElementById('addQuantity');
    this.addButton = document.getElementById('addButton');
  }

  get itemName() {
    return this.itemInput.value.trim();
  }

  get quantity() {
    return this.quantityInput.value.trim();
  }

  resetInput() {
    this.itemInput.value = '';
    this.quantityInput.value = '';
    this.itemInput.classList.remove('is-invalid');
    this.quantityInput.classList.remove('is-invalid');
  }

  showInvalidInput() {
    if (this.itemName === '') {
      this.itemInput.classList.add('is-invalid');
    }
    if (this.quantity === '') {
      this.quantityInput.classList.add('is-invalid');
    }
  }

  displayGroceries(groceries) {
    render(this.groceriesTemplate(groceries), this.app);
  }

  groceriesTemplate(groceries) {
    return html`
      ${groceries.map((item, index) => this.groceryTemplate(item, index))}
    `;
  }

  groceryTemplate({ itemName, quantity, productInfo }, index) {
    return html`
      <li class="list-group-item grocery-item" data-index="${index}">
        <div class="grocery-text">
          <strong>${itemName}</strong>
          <span class="badge text-bg-secondary quantity-chip">${quantity}</span>
        </div>
        ${productInfo?.notFound ? html`
          <span class="product-not-found">No nutrition info found</span>
        ` : productInfo ? html`
          <div class="product-details">
            ${productInfo.brand ? html`<span class="product-brand">${productInfo.brand}</span>` : ''}
            ${productInfo.description ? html`<span class="product-name">${productInfo.description}</span>` : ''}
            ${productInfo.nutrients?.length ? html`
              <span class="nutrition-panel">
                <span class="nutrition-serving">per ${productInfo.servingSize}</span>
                ${productInfo.nutrients.map((n, i) => html`
                  ${i > 0 ? html`<span class="nutrient-sep">·</span>` : ''}
                  <span class="nutrient-value">${n.display}</span>
                `)}
              </span>
            ` : ''}
          </div>
        ` : ''}
        <button name="deleteGrocery" type="button" class="btn p-0 border-0 ms-auto" aria-label="Delete grocery item">
          <i class="bi-trash delete-icon"></i>
        </button>
      </li>
    `;
  }

  onAddGrocery(handler) {
    this.addButton.addEventListener('click', () => {
      if (this.itemName !== '' && this.quantity !== '') {
        handler(this.itemName, this.quantity);
        this.resetInput();
      } else {
        this.showInvalidInput();
      }
    });
  }

  onDeleteGrocery(handler) {
    this.app.addEventListener('click', ({ target }) => {
      const deleteButton = target.closest('button[name="deleteGrocery"]');
      if (deleteButton) {
        const index = parseInt(deleteButton.closest('li').getAttribute('data-index'), 10);
        handler(index);
      }
    });
  }
}
